import React from "react";
import Autosuggest from "react-autosuggest";

const AirportDeparture = ({
  index,
  departureValue,
  airportDetails,
  changeDepartureInput,
  departureSelected,
  depSuggestions,
  setDepSuggestions,
}) => {
  // const escapeRegexCharacters = (str) => {
  //   return str.replace(/[.*+?^${}()|[]]/g, "$&");
  // };

  const getSuggestions = (value) => {
    // const escapedValue = escapeRegexCharacters(value.trim());
    // if (escapedValue === "") {
    //   return [];
    // }
    // debugger;
    // const regex = new RegExp(`^${escapedValue}`, "i");
    const filterResult = airportDetails.filter((airport) =>
      airport.label.toLowerCase().includes(value.trim().toLowerCase())
    );
    return filterResult;
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setDepSuggestions(getSuggestions(value));
  };

  const onSuggestionSelected = (event, { suggestionValue }) => {
    departureSelected(suggestionValue);
  };

  const onSuggestionsClearRequested = () => {
    setDepSuggestions([]);
  };

  const getSuggestionValue = (suggestion) => {
    return suggestion;
  };

  const renderSuggestion = (suggestion) => {
    return <div> {suggestion.label} </div>;
  };

  const renderInputComponent = (props) => (
    <input {...props} className="form-control" required />
  );

  return (
    <Autosuggest
      suggestions={depSuggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={true}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder: "Airport Departure",
        value: departureValue[index] && departureValue[index].label,
        onChange: (e) => changeDepartureInput(e.target.value, index),
        id: `flightLegs.return[${index}].airportDepartureId`,
        name: `flightLegs.return[${index}].airportDepartureId`,
      }}
      renderInputComponent={renderInputComponent}
    />
  );
};

export default AirportDeparture;
